import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import {
  Button,
  Grid,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
} from '@material-ui/core';
import { dialogModes, parameterInitialState } from '../Constants';
import { addParameter, updateParameter } from './parameterServices';

function ParameterDialog({
  isModalOpen,
  toggleModal,
  dialogMode,
  parameterToEdit,
  changeDialogMode,
  setParameterToEdit,
  addNewParameter,
  editParameter,
}) {
  useEffect(() => {
    if (parameterToEdit) setNewParameter(parameterToEdit);
  }, [parameterToEdit]);

  const [newParameter, setNewParameter] = useState(
    parameterToEdit ? parameterToEdit : parameterInitialState
  );

  const updateParameter = (propName, propValue) => {
    const parameter = { ...newParameter };
    parameter[propName] = propValue;
    setNewParameter(parameter);
  };

  const onAddNewParameter = () => {
    addNewParameter(newParameter, () => {
      setNewParameter(parameterInitialState);
      toggleModal(false);
    });
  };

  const onEditParameter = () => {
    editParameter(newParameter, () => {
      setNewParameter(parameterInitialState);
      toggleModal(false);
      changeDialogMode(dialogModes.add);
      setParameterToEdit(null);
    });
  };

  const upsertParameter = () =>
    dialogMode === dialogModes.add ? onAddNewParameter() : onEditParameter();

  const cancelAddParameter = () => {
    setNewParameter(parameterInitialState);
    changeDialogMode(dialogModes.add);
    setParameterToEdit(null);
    toggleModal(false);
  };

  return (
    <Dialog open={isModalOpen}>
      <DialogTitle>{`${
        dialogMode === dialogModes.add ? 'Add new' : 'Update'
      } Parameter`}</DialogTitle>
      <DialogContent>
        <Grid container style={{ flexGrow: 1 }} justify="center">
          <TextField
            id="name"
            label="Parameter name"
            variant="outlined"
            fullWidth
            style={{ marginBottom: '16px' }}
            value={newParameter.name}
            onChange={(e) => updateParameter('name', e.target.value)}
            autoFocus
            required
            error={!newParameter.name}
          />
          <TextField
            id="importance"
            label="Importance"
            variant="outlined"
            fullWidth
            value={newParameter.importance}
            onChange={(e) => updateParameter('importance', e.target.value)}
            required
            type="number"
            error={
              !newParameter.importance ||
              newParameter.importance < 1 ||
              newParameter.importance > 5
            }
            helperText={
              newParameter.importance !== '' &&
              (newParameter.importance < 1 || newParameter.importance > 5) &&
              'Importance value must be between 1 to 5'
            }
          />
        </Grid>
      </DialogContent>
      <DialogActions>
        <Button
          disabled={!newParameter.name || !newParameter.importance}
          variant="outlined"
          color="primary"
          onClick={upsertParameter}
        >
          {dialogMode === dialogModes.add ? 'Add' : 'Update'}
        </Button>
        <Button
          variant="outlined"
          onClick={cancelAddParameter}
          color="secondary"
        >
          Cancel
        </Button>
      </DialogActions>
    </Dialog>
  );
}

const mapDispatchToProps = (dispatch, ownProps) => ({
  addNewParameter: (parameter, cb) => dispatch(addParameter(parameter, cb)),
  editParameter: (parameter, cb) => dispatch(updateParameter(parameter, cb)),
});

export default connect(null, mapDispatchToProps)(ParameterDialog);



// WEBPACK FOOTER //
// ./src/parameter/ParameterDialog.js